import * as React from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'
import * as LabelPrimitive from '@radix-ui/react-label'

export const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={`relative flex w-full touch-none select-none items-center ${className}`}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-2 border-primary bg-primary ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={`text-sm font-medium leading-none text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={`ace-input disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export const Card = ({ className, ...props }) => (
  <div
    className={`rounded-xl border border-border bg-card text-card-foreground ${className}`}
    {...props}
  />
)
Card.displayName = "Card"

export const CardHeader = ({
  className,
  ...props
}) => (
  <div
    className={`flex flex-col space-y-1.5 px-5 py-3 ${className}`}
    {...props}
  />
)
CardHeader.displayName = "CardHeader"

export const CardTitle = ({
  className,
  children,
  ...props
}) => (
  <h3
    className={`text-lg font-semibold leading-none tracking-tight text-primary ${className}`}
    {...props}
  >
    {children}
  </h3>
)
CardTitle.displayName = "CardTitle"

export const CardContent = ({
  className,
  ...props
}) => (
  <div className={`p-5 pt-0 ${className}`} {...props} />
)
CardContent.displayName = "CardContent"

export const Button = ({ className, children, ...props }) => (
  <button
    className={`ace-button-primary disabled:pointer-events-none disabled:opacity-50 ${className}`}
    {...props}
  >
    {children}
  </button>
)
Button.displayName = "Button"

export const Tooltip = ({ className, title, subtitle, ...props }) => (
  <div
    className={`ace-tooltip p-2 ${className}`}
    {...props}
  >
    <div className="text-sm font-semibold text-foreground">{title}</div>
    {subtitle && <div className="mt-2 text-sm font-normal text-muted-foreground">{subtitle}</div>}
  </div>
)
Tooltip.displayName = "Tooltip"

// Add these new exports for Select components
export { Select, SelectGroup, SelectValue, SelectTrigger, SelectContent, SelectLabel, SelectItem, SelectSeparator } from './select';